import { Directive, ElementRef, Input, OnChanges, SimpleChanges, Renderer, Renderer2 } from '@angular/core';

@Directive({
  selector: '[appTouchlineHighlight]'
})
export class TouchlineHighlightDirective /* implements OnChanges */ {

  @Input('appTouchlineHighlight') appTouchlineHighlight: string;
  // @Input('data') data: any;
  @Input()
  set data(data:any) {
    let coloumns = ["buyQty", "buyPrice", "sellQty", "sellPrice", "lastPrice", "netChangePercentage", "netChangeValue"];
    if (coloumns.includes(this.appTouchlineHighlight)) {
      // console.log("Ng on change", data, this.oldValue);
      // console.log("inside directive: ", this.appTouchlineHighlight);
      // console.log("data", this.data);
      // console.log("oldValue", this.oldValue);

      this.renderer.removeClass(this.el.nativeElement, 'mkt-incr');
      this.renderer.removeClass(this.el.nativeElement, 'mkt-decr');
      // if (!changes.data.isFirstChange()) {
        if (data > this.oldValue && data != 0) {
          this.renderer.addClass(this.el.nativeElement, 'mkt-incr');
          // this.el.nativeElement.style.backgroundColor = 'blue';
        } else if (data < this.oldValue && data != 0) {
          this.renderer.addClass(this.el.nativeElement, 'mkt-decr');
          // this.el.nativeElement.style.backgroundColor = 'red';
        }
        this.oldValue = data;
      // }
    }
  }

  oldValue;

  constructor(private el: ElementRef, private renderer: Renderer2) {
  }

  ngOnInit() {
    // let coloumns = ["buyQty", "buyPrice", "sellQty", "sellPrice", "netChangePercentage", "netChangeValue"];
    // let buy = ["buyPrice", "lastPrice"];
    // if (buy.includes(this.appTouchlineHighlight)) {
    //   this.renderer.addClass(this.el.nativeElement, 'buy-color');
    // }
    // if (this.appTouchlineHighlight == "sellPrice") {
    //   this.renderer.addClass(this.el.nativeElement, 'sell-color');
    // }
  }

  // ngOnChanges(changes: SimpleChanges) {
  //   let coloumns = ["buyQty", "buyPrice", "sellQty", "sellPrice", "netChangePercentage", "netChangeValue"];
  //   if (coloumns.includes(this.appTouchlineHighlight)) {
  //     console.log("Ng on change", changes);
  //     // console.log("inside directive: ", this.appTouchlineHighlight);
  //     // console.log("data", this.data);
  //     // console.log("oldValue", this.oldValue);
  //     // this.oldValue = this.data;

  //     this.renderer.removeClass(this.el.nativeElement, 'mkt-incr');
  //     this.renderer.removeClass(this.el.nativeElement, 'mkt-decr');
  //     if (!changes.data.isFirstChange()) {
  //       if (changes.data.currentValue > changes.data.previousValue) {
  //         this.renderer.addClass(this.el.nativeElement, 'mkt-incr');
  //         // this.el.nativeElement.style.backgroundColor = 'blue';
  //       } else if (changes.data.currentValue < changes.data.previousValue) {
  //         this.renderer.addClass(this.el.nativeElement, 'mkt-decr');
  //         // this.el.nativeElement.style.backgroundColor = 'red';
  //       }
  //     }

  //     // this.oldValue = this.data;
  //     // this.el.nativeElement.style.backgroundColor = 'yellow';
  //   }
  // }

}
